import { UtilityBar } from "@/components/organisms/UtilityBar";

export function JournalEntriesSubnav() {
  return (
    <>
      <UtilityBar />
    </>
  );
}
